import { memo, useEffect, useState, useRef, useCallback } from 'react';
import DragDrawer from '@/sub-luca-plugin/components/drag-drawer';
import DrawerToast from '@/sub-luca-plugin/components/drawer-toast';
import QuestionDetail from '@/sub-luca-plugin/components/qa-detail-render';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { getQaStore } from '@/sub-luca-plugin/store/qa';

const QaDetailDrawer = () => {
    const currentCollectStatus = useRef<boolean>();
    const callbacksRef = useRef<Record<string, (data: any) => void>>();
    const [info, setInfo] = useState<{ type: 'gbot_detail' | 'qa_pair_detail'; id: number }>();
    const [visible, setVisible] = useState(false);

    const handleCollectActionChange = useCallback((status: boolean) => {
        currentCollectStatus.current = status;
    }, []);

    const handleCloseDrawer = () => {
        setVisible(false);
        // 延迟清空数据
        setTimeout(() => setInfo(undefined), 500);
        getQaStore()?.updateQaConfig({ canExcuteAimation: false });
        callbacksRef.current?.onClose({ collectFlag: currentCollectStatus.current });
    };

    useEffect(() => {
        eventBusExample.subscribe('QaDetailRightDrawer', ({ type, params = {}, callbacks }) => {
            switch (type) {
                case 'open':
                    callbacksRef.current = callbacks;
                    setVisible(true);
                    setInfo(params);
                    setTimeout(() => {
                        getQaStore()?.updateQaConfig({ canExcuteAimation: true });
                    }, 500);
                    break;
                default:
                    handleCloseDrawer();
                    break;
            }
        });
    }, []);

    return (
        <DragDrawer width={375} open={visible} onClose={handleCloseDrawer}>
            <DrawerToast subscribeName="QaDetailToast" />
            <QuestionDetail {...(info || ({} as any))} onCollectStatusChange={handleCollectActionChange} onClose={handleCloseDrawer} />
        </DragDrawer>
    );
};

export default memo(QaDetailDrawer);
